(function () {
  'use strict';

  function progressTrackerFactory ($state, $location, Common) {
    const factory = {};

    function checkSenderInfo () {
      const requiredFields = ['addressLineOne', 'country', 'street', 'zipcode', 'city'];
      const senderInfo = Common.get('senderInfo', {});
      let valid = true;

      if (Common.get('serviceType').indexOf('admail-') < 0) {
        requiredFields.forEach(function (item) {
          if (!senderInfo[item] || senderInfo[item] === '') {
            valid = false;
          }
        });
      }

      return valid;
    }

    function checkMaterial () {
      const conditions = {
        0: Common.get('pdfApproved', false) && Common.get('s3Pdf', false) && Common.get('materialDetails', false),
        1: Common.get('materialDetails', false)
      };

      return conditions[Number(Common.get('serviceType', 'information') === 'admail-odr')];
    }

    function checkProduct () {
      return Common.get('productDelivery', false);
    }

    function checkRecipients () {
      return (Common.get('recipients.validAddressCount', 0) || Common.get('recipients.refinedAddressCount', 0)) && checkSenderInfo() && Common.get('sendoutName', false);
    }

    function checkAll () {
      return checkRecipients() && checkProduct() && checkMaterial();
    }

    // checks the existence of the required keys in the localStorage
    // if these keys are in the localStorage, allow redirection in the recipients page
    function checkRecipientsInputs () {
      return Common.get('recipients', false) && Common.get('senderInfo', false) && Common.get('sendoutName', false);
    }

    // this is for case for product gets reset when usertype switches from anonymous to ncp
    function checkProductOnClick () {
      return checkProduct() || (!checkProduct() && checkRecipients());
    }

    function hasSavedCampaign () {
      return Common.get('serviceType', false) && (checkRecipients() || checkProduct() || checkMaterial());
    }

    function getContinuePath () {
      const allValid = checkAll();
      let path = '/';

      if (!allValid && !checkMaterial()) {
        path = '/message';
      }

      if (!allValid && !checkProduct()) {
        path = Common.get('recipients.addressType', 'ADR') === 'ODR' ? '/where-to/odr' : '/where-to';
      }

      if (!allValid && !checkRecipients()) {
        path = '/recipients';
      }

      if (allValid) {
        path = '/payment';
      }

      return path;
    }

    factory.checkRecipients = checkRecipients;
    factory.checkProduct = checkProduct;
    factory.checkMaterial = checkMaterial;
    factory.checkRecipientsInputs = checkRecipientsInputs;
    factory.checkProductOnClick = checkProductOnClick;
    factory.checkAll = checkAll;
    factory.hasSavedCampaign = hasSavedCampaign;
    factory.getContinuePath = getContinuePath;

    return factory;
  }

  angular.module('web2print')
    .factory('progressTrackerFactory', progressTrackerFactory);
})();
